import { MessageCircle } from "lucide-react";
import { Logo } from "./Logo";
import { WHATSAPP_URL, scrollToSection } from "@/lib/site";

const LINKS = [
  { label: "Come funziona", hash: "#come-funziona", testid: "nav-how" },
  { label: "Perché conviene", hash: "#benefici", testid: "nav-benefits" },
  { label: "Prodotti", hash: "#prodotti", testid: "nav-products" },
  { label: "FAQ", hash: "#faq", testid: "nav-faq" },
];

export const Navbar = () => (
  <header className="fixed inset-x-0 top-0 z-50 border-b border-slate-200/60 bg-white/80 backdrop-blur-md">
    <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
      <button onClick={() => scrollToSection("#top")} className="cursor-pointer" data-testid="nav-logo-btn" aria-label="Torna su">
        <Logo />
      </button>
      <nav className="hidden items-center gap-8 md:flex">
        {LINKS.map((l) => (
          <button
            key={l.hash}
            data-testid={l.testid}
            onClick={() => scrollToSection(l.hash)}
            className="text-sm font-medium text-slate-600 transition-colors duration-200 hover:text-[#4285F4]"
          >
            {l.label}
          </button>
        ))}
      </nav>
      <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="nav-whatsapp-cta"
        className="group flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2 text-sm font-semibold text-white shadow-lg shadow-green-500/25 transition-transform duration-200 hover:scale-105 hover:bg-[#1EBE5D]"
      >
        <MessageCircle className="h-4 w-4 transition-transform duration-200 group-hover:-rotate-12" />
        <span className="hidden sm:inline">Richiedi preventivo</span>
        <span className="sm:hidden">Preventivo</span>
      </a>
    </div>
  </header>
);
